/*
      ___           ___
     /\  \         /\  \
    /::\  \       /::\  \
   /:/\:\  \     /:/\ \  \
  /::\ \:\  \   _\:\ \ \  \
 /:/\:\ \:\__\ /\ \:\ \ \__\
 \/_|::\/:/  / \:\ \:\ \/__/
    |:|::/  /   \:\ \:\__\
    |:|\/__/     \:\/:/  /
    |:|  |        \::/  /
     \|__|         \/__/

    Developed by Ralph Shippam - 2019.
*/

import {
    Component,
    Inject, OnInit,
} from '@angular/core';

import {
    MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA
} from '@angular/material/bottom-sheet';

@Component({
    selector: 'app-rs-bottom-sheet',
    templateUrl: 'rsbottomsheet.component.html',
    styleUrls: ['rsbottomsheet.component.scss'],
    exportAs: 'RSBottomSheetComponent'
})
export class RSBottomSheetComponent implements OnInit {

    constructor(
        public dialogRef: MatBottomSheetRef<RSBottomSheetComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: any) {}

    ngOnInit() {
        console.log('RSBottomSheetComponent::: init');
    }

}
